import { render, staticRenderFns } from "./SubEnterpriseForm.vue?vue&type=template&id=b10f3412&scoped=true"
import script from "./SubEnterpriseForm.vue?vue&type=script&lang=js"
export * from "./SubEnterpriseForm.vue?vue&type=script&lang=js"
import style0 from "./SubEnterpriseForm.vue?vue&type=style&index=0&id=b10f3412&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10f3412",
  null
  
)

export default component.exports